import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row items-center q-gutter-sm" }
const _hoisted_2 = { class: "text-grey-5" }
const _hoisted_3 = { class: "row no-wrap items-center justify-end" }
const _hoisted_4 = {
  key: 3,
  style: {"width":"33px"}
}
const _hoisted_5 = { class: "column q-gutter-sm" }
const _hoisted_6 = { class: "row justify-end q-gutter-sm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "q-px-md q-pb-sm bg-grey-2" }
const _hoisted_9 = { class: "row justify-end q-gutter-sm q-mt-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Stream Manager ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onClose
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_toolbar, {
          dense: "",
          class: "q-mt-xs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand text-subtitle2" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Live Streams ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "refresh",
              size: "sm",
              onClick: _ctx.refresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Refresh sessions", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, { class: "q-pt-none q-pb-sm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_select, {
                modelValue: _ctx.selectedDevice,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDevice) = $event)),
                options: _ctx.filteredDeviceOptions,
                label: "Select device",
                dense: "",
                outlined: "",
                "option-label": "label",
                "option-value": "uid",
                "emit-value": "",
                "map-options": "",
                "use-input": "",
                "input-debounce": "200",
                class: "col",
                loading: _ctx.loadingDevices,
                onPopupShow: _ctx.fetchDevices,
                onFilter: _ctx.onFilterDevices
              }, {
                option: _withCtx((scope) => [
                  _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.opt.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_badge, {
                            color: scope.opt.isConnected ? 'green' : 'grey',
                            label: scope.opt.isConnected ? 'online' : 'offline'
                          }, null, 8, ["color", "label"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["modelValue", "options", "loading", "onPopupShow", "onFilter"]),
              _createVNode(_component_q_btn, {
                dense: "",
                outline: !_ctx.onlineOnly,
                color: _ctx.onlineOnly ? 'green' : 'grey',
                icon: "wifi",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onlineOnly = !_ctx.onlineOnly))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.onlineOnly ? 'Showing online only' : 'Showing all devices'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["outline", "color"]),
              _createVNode(_component_q_btn, {
                dense: "",
                color: "primary",
                label: "Start",
                disable: _ctx.selectedDevice === null,
                onClick: _ctx.startSession
              }, null, 8, ["disable", "onClick"])
            ])
          ]),
          _: 1
        }),
        (_ctx.activeDeviceSessions.length === 0)
          ? (_openBlock(), _createBlock(_component_q_card_section, {
              key: 0,
              class: "q-pt-none"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "text-grey-6 text-center q-py-md" }, " No active stream sessions ", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_q_list, {
              key: 1,
              separator: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeDeviceSessions, (device) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: device.uid,
                    class: _normalizeClass(["q-py-sm", { 'stream-active-item': _ctx.isStreamOpen(device.uid) }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, { class: "text-weight-medium" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" UID " + _toDisplayString(device.uid), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(device.activeSessionCount) + " " + _toDisplayString(device.activeSessionCount === 1 ? 'viewer' : 'viewers'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(device.sessions, (session) => {
                            return (_openBlock(), _createBlock(_component_q_item_label, {
                              key: session.streamSessionId,
                              caption: "",
                              class: "q-ml-sm"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(session.userName) + " ", 1),
                                _createElementVNode("span", _hoisted_2, " — joined " + _toDisplayString(_ctx.formatTime(session.createdDate)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, {
                        side: "",
                        style: {"min-width":"80px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            (!_ctx.isStreamOpen(device.uid))
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 0,
                                  flat: "",
                                  dense: "",
                                  color: "primary",
                                  icon: "play_arrow",
                                  onClick: ($event: any) => (_ctx.openStream(device.uid))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode("Open stream", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 1,
                                  name: "sensors",
                                  color: "green",
                                  size: "sm",
                                  class: "q-mr-xs"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createTextVNode("Active in realtime plot", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })),
                            (_ctx.isViewerOn(device))
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 2,
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "logout",
                                  onClick: ($event: any) => (_ctx.leaveStream(device.uid))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createTextVNode("Leave session", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                }), 128))
              ]),
              _: 1
            })),
        _createVNode(_component_q_separator, { class: "q-mt-sm" }),
        _createVNode(_component_q_toolbar, {
          dense: "",
          class: "q-mt-xs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand text-subtitle2" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Stream Recordings ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              size: "sm",
              color: _ctx.activeFilterCount > 0 ? 'primary' : '',
              icon: "filter_list",
              onClick: _ctx.toggleFilters
            }, {
              default: _withCtx(() => [
                (_ctx.activeFilterCount > 0)
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 0,
                      color: "primary",
                      floating: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.activeFilterCount), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.showFilters ? 'Hide filters' : 'Show filters'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color", "onClick"]),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "refresh",
              size: "sm",
              onClick: _ctx.fetchRecordings
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Refresh recordings", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_slide_transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_card_section, { class: "q-pt-none q-pb-sm" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.recordingUidFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recordingUidFilter) = $event)),
                    modelModifiers: { number: true },
                    dense: "",
                    outlined: "",
                    clearable: "",
                    type: "number",
                    label: "Filter by UID",
                    onKeyup: _withKeys(_ctx.applyFilters, ["enter"]),
                    onClear: _ctx.applyFilters
                  }, null, 8, ["modelValue", "onKeyup", "onClear"]),
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.selectedPigRunId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPigRunId) = $event)),
                    options: _ctx.pigRunOptions,
                    label: "Filter by pig run",
                    dense: "",
                    outlined: "",
                    clearable: "",
                    "emit-value": "",
                    "map-options": "",
                    "option-label": "label",
                    "option-value": "value",
                    loading: _ctx.loadingPigRuns
                  }, null, 8, ["modelValue", "options", "loading"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      dense: "",
                      label: "Clear",
                      disable: _ctx.activeFilterCount === 0,
                      onClick: _ctx.clearFilters
                    }, null, 8, ["disable", "onClick"]),
                    _createVNode(_component_q_btn, {
                      dense: "",
                      color: "primary",
                      label: "Apply",
                      onClick: _ctx.applyFilters
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.showFilters]
            ])
          ]),
          _: 1
        }),
        (_ctx.filteredRecordings.length === 0)
          ? (_openBlock(), _createBlock(_component_q_card_section, {
              key: 2,
              class: "q-pt-none"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createElementVNode("div", { class: "text-grey-6 text-center q-py-sm text-caption" }, " No recordings found ", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_q_list, {
              key: 3,
              dense: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRecordings, (rec) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rec.streamRecordingId,
                    class: _normalizeClass(["recording-row", {
            'playback-active-item':
              rec.streamRecordingId === _ctx.activePlaybackRecordingId,
          }])
                  }, [
                    _createVNode(_component_q_item, { class: "q-py-xs" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, { class: "text-weight-medium text-caption" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" UID " + _toDisplayString(rec.uid), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (rec.pigRunId)
                              ? (_openBlock(), _createBlock(_component_q_item_label, {
                                  key: 0,
                                  caption: "",
                                  class: "text-primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "route",
                                      size: "xs",
                                      class: "q-mx-xs"
                                    }),
                                    _createTextVNode(" Pigrun: " + _toDisplayString(rec.pigRunName), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (rec.pigRunMarkerName)
                              ? (_openBlock(), _createBlock(_component_q_item_label, {
                                  key: 1,
                                  caption: "",
                                  class: "text-primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "place",
                                      size: "xs",
                                      class: "q-mx-xs"
                                    }),
                                    _createTextVNode(" Marker: " + _toDisplayString(rec.pigRunMarkerName), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_q_item_label, { caption: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatRecordingTime(rec.startedDateUtc)) + " ", 1),
                                (rec.stoppedDateUtc)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " — " + _toDisplayString(_ctx.formatRecordingDuration(
                      rec.startedDateUtc,
                      rec.stoppedDateUtc
                    )), 1))
                                  : _createCommentVNode("", true),
                                (rec.isActive)
                                  ? (_openBlock(), _createBlock(_component_q_badge, {
                                      key: 1,
                                      color: "red",
                                      label: "recording",
                                      class: "q-ml-xs"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              size: "sm",
                              color: rec.notes ? 'primary' : 'grey-6',
                              icon: rec.notes ? 'sticky_note_2' : 'note_add',
                              onClick: ($event: any) => (_ctx.toggleNotes(rec.streamRecordingId))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(rec.notes ? 'View / edit note' : 'Add note'), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["color", "icon", "onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            (rec.streamRecordingId === _ctx.activePlaybackRecordingId)
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 0,
                                  name: "sensors",
                                  color: "green",
                                  size: "sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createTextVNode("Currently playing", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (rec.isActive)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    flat: "",
                                    dense: "",
                                    color: "red",
                                    icon: "stop",
                                    size: "sm",
                                    onClick: ($event: any) => (_ctx.stopRecording(rec.streamRecordingId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                          _createTextVNode("Stop recording", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 2,
                                    flat: "",
                                    dense: "",
                                    color: "primary",
                                    icon: "play_arrow",
                                    size: "sm",
                                    onClick: ($event: any) => (_ctx.playbackRecording(rec.streamRecordingId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                          _createTextVNode("Play back recording", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                          ]),
                          _: 2
                        }, 1024),
                        (
                !rec.isActive &&
                rec.streamRecordingId !== _ctx.activePlaybackRecordingId
              )
                          ? (_openBlock(), _createBlock(_component_q_item_section, {
                              key: 0,
                              side: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "delete",
                                  size: "sm",
                                  onClick: ($event: any) => (_ctx.confirmDeleteRecording(rec.streamRecordingId))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                        _createTextVNode("Delete recording", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_slide_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.notesDraft,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notesDraft) = $event)),
                            type: "textarea",
                            outlined: "",
                            dense: "",
                            autogrow: "",
                            label: "Notes",
                            disable: _ctx.savingNotes
                          }, null, 8, ["modelValue", "disable"]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              label: "Cancel",
                              disable: _ctx.savingNotes,
                              onClick: _ctx.cancelNotesEdit
                            }, null, 8, ["disable", "onClick"]),
                            _createVNode(_component_q_btn, {
                              dense: "",
                              color: "primary",
                              label: "Save",
                              loading: _ctx.savingNotes,
                              onClick: ($event: any) => (_ctx.saveNotes(rec))
                            }, null, 8, ["loading", "onClick"])
                          ])
                        ], 512), [
                          [_vShow, _ctx.expandedRecordingId === rec.streamRecordingId]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ], 2))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showInstructions,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showInstructions) = $event)),
      title: "Stream Manager",
      icon: "sensors",
      message: "Start or join a live stream, or record a stream and play it back later. You will find recordings in the Stream Recordings section.",
      tip: "Use the filter icon to narrow recordings by UID or Pig Run."
    }, null, 8, ["modelValue"])
  ], 512)), [
    [_vShow, _ctx.showStreamManager]
  ])
}